export default "__VITE_PUBLIC_ASSET__7b34cf56__"